import { render, staticRenderFns } from "./protocol-list.vue?vue&type=template&id=5161ac10&scoped=true"
import script from "./protocol-list.vue?vue&type=script&lang=js"
export * from "./protocol-list.vue?vue&type=script&lang=js"
import style0 from "./protocol-list.vue?vue&type=style&index=0&id=5161ac10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161ac10",
  null
  
)

export default component.exports